import { useSegmentAnalytics } from '@nerdwallet/seo-analytics';
import analytics from '@nerdwallet/analytics';
import { useSegmentImpressionContext } from './segment-impression';
import { SegmentFieldEventPayloadT } from './types';

const useAnalytics = <T>(): {
  track: (
    eventType: string,
    eventPayload: SegmentFieldEventPayloadT<T>
  ) => Promise<void>;
} => {
  // eslint-disable-next-line camelcase
  const parent_event_id = useSegmentImpressionContext()?.eventId;
  const segment = useSegmentAnalytics()?.analytics;

  const track = async (
    eventType: string,
    eventPayload: SegmentFieldEventPayloadT<T>
  ) => {
    segment?.track(eventType, {
      parent_event_id,
      event_id: analytics.uuid(),
      ...eventPayload,
    });
  };

  return { track };
};

export default useAnalytics;
